export const handleCompanySelect = companyOption => dispatch => {
  if (!companyOption.url) return console.error('No redirect url for', companyOption)

  window.open(companyOption.url, '_top')
}
